import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    Filter,
    EmailField,
    DateField,
    ShowButton,
    ChipField,
    FunctionField,
    SelectArrayInput,
} from 'react-admin';
import CustomSearchInput from '../components/CustomSearchInput';
import BoxitPagination from '../components/BoxitPagination';
import BoxitChipField from '../components/BoxitChipField';
import MoneyField from '../components/MoneyField';
import CountryField from '../components/CountryField';
import UserReferenceField from '../components/UserReferenceField';
import { ListProps, User } from '../types';
import { UserStatus } from '../constants';

const CustomerUsersFilter = props => (
    <Filter variant="outlined" {...props}>
        <CustomSearchInput alwaysOn />
        <SelectArrayInput
            style={{ minWidth: '10rem' }}
            source="status"
            choices={Object.keys(UserStatus).map(c => ({ id: c, name: c }))}
            alwaysOn
        />
    </Filter>
);

const CustomerUsersList: React.FC<ListProps<User>> = ({
    permissions = [],
    ...props
}) => {
    // Apply filter for customer users (non-staff)
    const filterDefaultValues = { type: { $ne: 'staff' } };

    return (
        <List
            title="Customers"
            bulkActionButtons={false}
            filters={<CustomerUsersFilter />}
            sort={{ field: 'id', order: 'DESC' }}
            pagination={<BoxitPagination />}
            perPage={10}
            filterDefaultValues={filterDefaultValues}
            basePath="/users"
            {...props}
        >
            <Datagrid rowClick="show">
                <TextField source="serial" sortable={false} />
                <TextField source="id" />
                <ChipField source="type" />
                <TextField source="name" />
                <EmailField source="email" />
                <TextField source="phone" />
                <UserReferenceField source="assigneeId" label="Assignee" />
                <CountryField />
                {permissions.indexOf('partner') === -1 && (
                    <MoneyField source="credits" showCurrency />
                )}
                <FunctionField
                    label="Tags"
                    render={record =>
                        record.tags
                            ? record.tags.length > 3
                                ? record.tags
                                      .map(item => item.name)
                                      .slice(0, 3)
                                      .join(', ') + '...'
                                : record.tags
                                      .map(item => item.name)
                                      .slice(0, 3)
                                      .join(', ')
                            : ''
                    }
                />
                <BoxitChipField record source="status" list="user" />
                <DateField source="createdAt" label="Created" showTime />
                <ShowButton style={{ padding: 0 }} />
            </Datagrid>
        </List>
    );
};

CustomerUsersList.defaultProps = {
    resource: 'users',
};

export default CustomerUsersList;
